import React, { useEffect, useState } from 'react';
import PageHeading from '../../components/PageHeading/PageHeading';
import { colors } from '../../config/constants';
import { useDispatch } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import Dropdown from '../../components/Dropdown/Dropdown';
import { handlingNullData } from '../../config/helpers';
import Copy from '../../components/Copy/Copy';
import Button from '../../components/Button/Button';
import { useParams } from 'react-router-dom';
import {
  CrawlJobProgressStatus,
  RequestMapping,
  RequestType,
  StatusMapping,
} from '../../config/enum';
import { successMessage } from '../../config/keyword';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import { errorMessage } from '../../config/errorsMsg';

type ResultProps = {
  host: string;
  id: string;
  siteUrl: string;
  siteNumber?: number;
  organizationId: string;
  organizationName: string;
  organizationCode: string;
  progressStatus: number;
  requestType: number;
  crawlStartDate: string;
  crawlEndDate: string;
  totalPages: number;
  createdDate: string;
  updatedDate: string;
  requestedBy: string;
  indexDataFileStoreDriveId: string;
  crawlDataFileStoreDriveId: string;
  crawlDateFullPath: string;
  indexDateFullPath: string;
  indexingStartDate: string;
  indexingEndDate: string;
  message: string;
};

type FileStoreProps = {
  code: string;
  drivePath: string;
  freeMemory: number;
  id: string;
  totalMemory: number;
  type: number;
};

type StateProps = {
  name: string;
  id: string;
  path: string;
};

type CrawlProps = {
  crawlDateFullPath: string;
  fileStoreDriveId: string;
  indexDataFileStoreDriveId: string;
};

const CrawlJobsView = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [crawlStorage, setCrawlStorage] = useState<CrawlProps>({
    crawlDateFullPath: '',
    fileStoreDriveId: '',
    indexDataFileStoreDriveId: '',
  });
  const [fileStoreCode, setFileStoreCode] = useState<StateProps[]>([
    { id: '', name: '', path: '' },
  ]);
  const [fileStorage, setFileStorage] = useState<any>({
    id: '',
    code: '',
    drivePath: '',
  });
  const [terminate, setTerminate] = useState<boolean>(false);
  const [terminateMsg, setTerminateMsg] = useState<boolean>(false);
  const [terminateMessage, setTerminatemessage] = useState<string>('');
  const [edit, setEdit] = useState(false);
  const [crawlJobDetails, setCrawlJobDetails] = useState<ResultProps>({
    host: '',
    siteUrl: '',
    siteNumber: 0,
    id: '',
    organizationId: '',
    organizationName: '',
    organizationCode: '',
    progressStatus: 0,
    requestType: 0,
    crawlStartDate: '',
    crawlEndDate: '',
    totalPages: 0,
    createdDate: '',
    updatedDate: '',
    requestedBy: '',
    indexDataFileStoreDriveId: '',
    crawlDataFileStoreDriveId: '',
    crawlDateFullPath: '',
    indexDateFullPath: '',
    indexingStartDate: '',
    indexingEndDate: '',
    message: '',
  });

  useEffect(() => {
    const breadcrumb = [
      { path: '/crawljobs', name: 'Crawl Jobs' },
      { path: `/crawlView`, name: 'Crawl Details' },
    ];
    dispatch(update_breadcrumb(breadcrumb));
    getCrawlJobById();
    getAllStorage();
    getStorageById(crawlStorage.fileStoreDriveId);
  }, []);

  const handleChangeText = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setCrawlStorage({ ...crawlStorage, [event.target.name]: event.target.value });
  };

  const getAllStorage = async () => {
    await instance
      .get('/filestore-drives')
      .then((response) => {
        if (response.status === 200) {
          setFileStoreCode(
            response.data.map((item: FileStoreProps) => {
              return { id: item.id, name: item.code, path: item.drivePath };
            })
          );
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const getCrawlJobById = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/crawl-jobs/${id}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const startCrawling = async () => {
    dispatch(updateIsLoading(true));
    instance
      .post(`/crawl-jobs/${id}/start-crawling`)
      .then(async (response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.CRAWL_INIT,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getCrawlJobById();
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const startIndexing = async () => {
    dispatch(updateIsLoading(true));
    instance
      .post(`/crawl-jobs/${id}/start-indexing`)
      .then(async (response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.CRAWL_START,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getCrawlJobById();
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const terminateSite = async () => {
    dispatch(updateIsLoading(true));
    instance
      .post(`/crawl-jobs/${id}/terminate`, { message: terminateMessage })
      .then(async (response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.CRAWL_TERMINATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getCrawlJobById();
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: ResultProps) => {
    setCrawlJobDetails(data);
    setCrawlStorage({
      ...crawlStorage,
      fileStoreDriveId: data.crawlDataFileStoreDriveId,
      indexDataFileStoreDriveId: data.indexDataFileStoreDriveId,
    });
    dispatch(updateIsLoading(false));
  };

  const updateCrawlJobs = async () => {
    const obj = {
      crawlDatePath:
        pathHandler().toString() + '\\' + crawlStorage.crawlDateFullPath,
      crawlDataFileStoreDriveId: crawlStorage.fileStoreDriveId,
      indexDataFileStoreDriveId: crawlStorage.indexDataFileStoreDriveId,
    };
    await instance
      .put(`/crawl-jobs/${id}/data-store`, obj)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.CRAWL_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          getCrawlJobById();
          getStorageById(crawlStorage.fileStoreDriveId);
          setCrawlStorage({
            ...crawlStorage,
            crawlDateFullPath: '',
            fileStoreDriveId: '',
            indexDataFileStoreDriveId: '',
          });
          setEdit(false);
          dispatch(updateFlashBar(obj));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const pathHandler = () => {
    return fileStoreCode
      .filter((item: StateProps) => item.id === crawlStorage.fileStoreDriveId)
      .map((data: StateProps) => {
        return data.path;
      });
  };

  const onMessageHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (event.target.value !== '' && event.target.value.length > 2) {
      setTerminatemessage(event.target.value);
      setTerminateMsg(true);
    } else {
      setTerminateMsg(false);
    }
  };

  const colorCheck = (arg: string) => {
    switch (arg) {
      case 'Pending':
        return 'bg-yellow-300 text-black';
      case 'Crawling':
        return 'bg-cyan-300 text-white';
      case 'Indexing':
        return 'bg-orange-400 text-white';
      case 'Completed':
        return 'bg-green-500 text-white';
      case 'Error':
        return 'bg-red-500 text-white';
      case 'Terminated':
        return 'bg-gray-400 text-white';
      default:
        return 'bg-white text-black';
    }
  };

  const onRestart = () => {
    dispatch(updateIsLoading(true));
    instance
      .post(`/crawl-jobs/${id}/re-start`)
      .then(async (response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.CRAWL_RESTART,
            type: flashBarTheme.SUCCESS,
          };
          getCrawlJobById();
          dispatch(updateFlashBar(obj));
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const getStorageById = async (arg: any) => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/filestore-drives/${arg}`)
      .then((response) => {
        if (response.status === 200) {
          setFileStorage(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.SUCCESS,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  return (
    <>
      <div className=" px-2">
        <PageHeading label="Crawl Details" />
        <div
          className={`bg-white flex flex-col justify-between relative shadow-lg ${colors.primaryText} rounded-sm p-4`}
        >
          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Site Host</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(crawlJobDetails?.host)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Site Url</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(crawlJobDetails?.siteUrl)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Site Number</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(crawlJobDetails?.siteNumber)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Organization Name</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(crawlJobDetails?.organizationName)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Organization Code</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(crawlJobDetails?.organizationCode)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Request Type</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(
                  RequestMapping[crawlJobDetails?.requestType as RequestType]
                )}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Requested By</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(crawlJobDetails?.requestedBy)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Total Pages</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(crawlJobDetails?.totalPages)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Created Date</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(crawlJobDetails?.createdDate)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Updated Date</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(crawlJobDetails?.updatedDate)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Crawl Start Date</div>
            <div className="text-black">
              {handlingNullData(crawlJobDetails?.crawlStartDate)}
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Crawl End Date</div>
            <div className="text-black">
              {handlingNullData(crawlJobDetails?.crawlEndDate)}
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Indexing Start Date</div>
            <div className="text-black">
              {handlingNullData(crawlJobDetails?.indexingStartDate)}
            </div>
          </div>

          <div className="sm:flex pb-7">
            <div className="sm:w-1/3">Indexing End Date</div>
            <div className="text-black">
              {handlingNullData(crawlJobDetails?.indexingEndDate)}
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Progress Status</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(
                  StatusMapping[
                    crawlJobDetails?.progressStatus as CrawlJobProgressStatus
                  ]
                )}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-7">
            <div className="sm:w-1/3">Message</div>
            <div className="text-black">
              {handlingNullData(crawlJobDetails?.message)}
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Crawl Data Full Path</div>
            <div className="flex sm:w-2/4">
              <div className="text-black flex">
                {handlingNullData(crawlJobDetails?.crawlDateFullPath)}
                {crawlJobDetails?.crawlDateFullPath !== null && (
                  <Copy path={crawlJobDetails?.crawlDateFullPath} isOpen={false} />
                )}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Index Data Full Path</div>
            <div className="flex sm:w-2/4">
              <div className="text-black flex">
                {handlingNullData(crawlJobDetails?.indexDateFullPath)}{' '}
                {crawlJobDetails?.indexDateFullPath !== null && (
                  <Copy path={crawlJobDetails?.indexDateFullPath} isOpen={false} />
                )}
              </div>
            </div>
          </div>
          <div
            className={`absolute right-6 ${colorCheck(
              StatusMapping[
                crawlJobDetails?.progressStatus as CrawlJobProgressStatus
              ]
            )} px-3 py-2 rounded-md`}
          >
            {handlingNullData(
              StatusMapping[
                crawlJobDetails?.progressStatus as CrawlJobProgressStatus
              ]
            )}
          </div>
        </div>
        {crawlJobDetails?.progressStatus === CrawlJobProgressStatus.Pending && (
          <div className="p-4 mt-3 bg-white rounded-md shadow-lg">
            <div className="sm:flex justify-between text-md mb-2">
              <div className="text-[#176b87] font-semibold">Crawl data location</div>
            </div>

            <div
              className={`sm:flex text-md mb-2 items-center ${colors.primaryText}`}
            >
              <div className="sm:w-1/3">Crawl Data Store</div>
              {edit ? (
                <div className="sm:w-2/4 my-1">
                  <Dropdown
                    name="fileStoreDriveId"
                    value={crawlStorage.fileStoreDriveId}
                    onChange={(event) => handleChangeText(event)}
                    initialOption={{
                      name: 'Select Crawl Root Folder',
                      id: '',
                    }}
                    options={fileStoreCode}
                  />
                </div>
              ) : (
                <div className="text-black">
                  {
                    fileStoreCode.filter(
                      (item: any) => item.id === crawlStorage.fileStoreDriveId
                    )[0]?.name
                  }
                </div>
              )}
            </div>

            {crawlStorage.fileStoreDriveId !== null && (
              <>
                {edit && (
                  <div className={`sm:flex text-md mb-2  ${colors.primaryText}`}>
                    <div className={`sm:w-1/3`}>Crawl Data Folder </div>
                    <span className="text-sm">
                      {pathHandler().toString().length < 50
                        ? pathHandler()
                        : pathHandler().toString().substring(0, 47) + '...'}
                      \
                      <input
                        autoComplete="off"
                        className="h-7 outline-none pl-2 text-sm border-b-2 focus:border-[#0369a1]"
                        type={'text'}
                        placeholder={'Enter folder'}
                        value={crawlStorage.crawlDateFullPath}
                        name={'crawlDateFullPath'}
                        onChange={(event) => handleChangeText(event)}
                      />
                    </span>
                  </div>
                )}
              </>
            )}

            <div
              className={`sm:flex text-md mb-2 items-center ${colors.primaryText}`}
            >
              <div className="sm:w-1/3">Index Data File Store</div>
              {edit ? (
                <div className="sm:w-2/4 my-1">
                  <Dropdown
                    name="indexDataFileStoreDriveId"
                    value={crawlStorage.indexDataFileStoreDriveId}
                    onChange={(event) => handleChangeText(event)}
                    initialOption={{
                      name: 'Select Crawl Root Folder',
                      id: '',
                    }}
                    options={fileStoreCode}
                  />
                </div>
              ) : (
                <div className="text-black">
                  {
                    fileStoreCode.filter(
                      (item: any) =>
                        item.id === crawlStorage.indexDataFileStoreDriveId
                    )[0]?.name
                  }
                </div>
              )}
            </div>
            <div className="flex items-center justify-end">
              {edit ? (
                <div className="flex space-x-2">
                  <Button
                    label="Update"
                    buttonType="primary"
                    disabled={
                      crawlStorage.fileStoreDriveId === '' ||
                      crawlStorage.indexDataFileStoreDriveId === '' ||
                      crawlStorage.crawlDateFullPath === ''
                    }
                    type="button"
                    onClick={() => updateCrawlJobs()}
                  />
                  <Button
                    label="Cancel"
                    buttonType="danger"
                    type="button"
                    onClick={() => setEdit(false)}
                  />
                </div>
              ) : (
                <Button
                  label="Edit"
                  buttonType="primary"
                  type="button"
                  onClick={() => setEdit(true)}
                />
              )}
            </div>
          </div>
        )}

        <div className="flex justify-center mt-4 space-x-3">
          {crawlJobDetails?.progressStatus === CrawlJobProgressStatus.Pending &&
            crawlJobDetails?.indexDataFileStoreDriveId !== null &&
            crawlJobDetails?.crawlDataFileStoreDriveId !== null &&
            crawlJobDetails?.crawlDateFullPath !== null && (
              <Button
                label="Start Crawling"
                buttonType="primary"
                type="button"
                onClick={startCrawling}
              />
            )}
          {crawlJobDetails?.progressStatus === CrawlJobProgressStatus.Crawling && (
            <Button
              label="Start Indexing"
              buttonType="success"
              type="button"
              onClick={startIndexing}
            />
          )}
          {crawlJobDetails?.progressStatus !== CrawlJobProgressStatus.Terminated &&
            crawlJobDetails?.progressStatus !== CrawlJobProgressStatus.Completed && (
              <div className="flex items-center flex-col relative">
                {terminate && (
                  <div
                    className={`bg-white rounded-xl p-4 my-5 border absolute min-w-[450px] bottom-[20px] text-center ${colors.primaryBorder}`}
                  >
                    <div className="text-[16px] font-semibold pb-2 text-[#686565]">
                      Please enter the reason for termination
                    </div>
                    <textarea
                      className={`w-full border focus:outline-none px-2 py-2 text-sm h-[90px]`}
                      onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                        onMessageHandler(event);
                      }}
                    ></textarea>
                    <div className="flex items-center justify-center mt-2 space-x-3">
                      <Button
                        label="Confirm Terminate"
                        buttonType="danger"
                        type="button"
                        onClick={terminateSite}
                        disabled={!terminateMsg}
                      />
                      <Button
                        label="Cancel"
                        buttonType="primary"
                        type="button"
                        onClick={() => {
                          setTerminate(false);
                        }}
                      />
                    </div>
                  </div>
                )}

                <Button
                  label="Terminate"
                  buttonType="danger"
                  type="button"
                  onClick={() => {
                    setTerminate(true);
                  }}
                  disabled={terminate}
                />
              </div>
            )}
          {crawlJobDetails?.progressStatus === CrawlJobProgressStatus.Error && (
            <Button
              label="Restart"
              buttonType="primary"
              type="button"
              onClick={() => {
                onRestart();
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CrawlJobsView;
